/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

export function useEffectOnce(effectFunction: () => void, dependencies: unknown[] = []) {
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current === true) effectFunction();

    return () => {
      effectRan.current = true;
    };
  }, dependencies);
}
